<template lang="pug">
  .review
    div
      h2 点评编辑
      .form-box(v-if="detail && step === 1")
        .user-box
          img(:src="(detail.HEADIMAGES && detail.HEADIMAGES.indexOf('http') === -1) ? $config.CONSTS.defaultAvatar : detail.HEADIMAGES")
          .user-info
            p {{ detail.REALNAME }}
            span {{ detail.COMPANY }}
            span {{ detail.OFFICE }} 发布于 {{ detail.lastoperationtime }}
        .form.flex
          el-form.half(:label-position="'left'")
            el-form-item.flex(label="产品")
              el-input(size="small" :disabled="true" v-model="detail.PRODUCTNAME")
            el-form-item.flex(label="类别")
              el-input(size="small" :disabled="true" v-model="detail.CATEGORYNAME")
            el-form-item.flex(label="厂商简称")
              el-input(size="small" :disabled="true" v-model="detail.FACTORYNAME")
            el-form-item.flex(label="综合评分")
              el-input(size="small" :disabled="true" v-model="detail.ztgsnum")
            el-form-item.flex(label="功能")
              el-input(size="small" :disabled="true" v-model="detail.FUNCTIONLEVEL")
            el-form-item.flex(label="性能")
              el-input(size="small" :disabled="true" v-model="detail.PERFORMANCELEVEL")
            el-form-item.flex(label="可扩展性")
              el-input(size="small" :disabled="true" v-model="detail.SCALABILITYLEVEL")
            el-form-item.flex(label="易部署性")
              el-input(size="small" :disabled="true" v-model="detail.DEPLOYLEVEL")
            el-form-item.flex(label="友好性")
              el-input(size="small" :disabled="true" v-model="detail.FRIENDLYLEVEL")
            el-form-item.flex(label="提交时间")
              el-input(size="small" :disabled="true" v-model="detail.lastoperationtime")

          el-form.half(:label-position="'left'")
            el-form-item.flex(label="优点")
              el-input(
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="detail.advantages")
            el-form-item.flex(label="不足之处")
              el-input(
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="detail.disadvantages")
            el-form-item.flex(label="建议提醒")
              el-input(
                type="textarea"
                autosize
                placeholder="请输入内容"
                v-model="detail.aftersales")
            el-form-item.flex(label="点评价值")
              el-input(size="small" :disabled="false" v-model="detail.editscoremark")
            el-form-item.flex(label="点评状态")
              el-radio(v-model="detail.isrecommendmark" :label="0") 有价值
              el-radio(v-model="detail.isrecommendmark" :label="1") 无价值
              el-radio(v-model="detail.isrecommendmark" :label="2") 疑似厂商点评


        .el-form-item.bottom-ctrl
          el-button(type="primary" @click="handleUpdate") 审核完毕
          el-button(@click="handleClose") 取消

</template>
<script>
import axios from 'axios'

export default {
  name: 'ReviewItem',
  props: ['reviewId', 'reviewStatus'],
  data () {
    return {
      step: 1,
      detail: null
    }
  },
  methods: {
    fetchData () {
      let url = `${this.$config.API.reviews.detail}/${this.reviewId}`
      axios.get(url)
        .then(res => {
          if (res.status === 200) {
            this.detail = res.data.transmitObj
            this.detail.editscoremark = res.data.transmitObj.ztgsnum
          }
        })
    },
    handleClose (e) {
      this.$parent.handleClose()
    },
    handleUpdate (e) {
      let url = this.$config.API.reviews.update
      let data = {
        review_id: this.reviewId,
        advantages: encodeURIComponent(escape(this.detail.advantages)),
        disadvantages: encodeURIComponent(escape(this.detail.disadvantages)),
        aftersales: encodeURIComponent(escape(this.detail.aftersales)),
        isrecommendmark: this.detail.isrecommendmark,
        editscoremark: this.detail.editscoremark
      }
      console.log('点评编辑审核完毕提交的数据:', data)
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          this.handleClose()
        }
      })
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>

<style lang="sass" scoped>
  .el-steps
    width: 50%
    margin: 20px auto
</style>



// WEBPACK FOOTER //
// Edit.vue?3a092d5f